const setDropDownHouseForSection2 = payload => {
  return {
    type: "setDropDownHouseForSection2",
    payload
  };
};
export default setDropDownHouseForSection2;
